import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Switch, Space, InputNumber, Alert, Select, TimePicker, Col, Row } from 'antd';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { createAgent } from '../../store/slices/userSlice';
import Password from 'antd/es/input/Password';
import { createUserAndAssignRole, getRoles } from '../../store/slices/roleSlice';

const AddSubAdmin = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    useEffect(() => {
        dispatch(getRoles())
    }, [dispatch])
    const { roles } = useSelector((state) => state?.role)
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createUserAndAssignRole({
                first_name : values?.first_name,
                last_name : values?.last_name,
                email : values?.email,
                phone : values?.phone,
                gender : values?.gender,
                role : values?.role,
                address : values?.address,
                password : values?.password,
            }));

            if (createUserAndAssignRole.fulfilled.match(resultAction)) {
                // navigate('/agents')
                setAlertMessage(resultAction?.payload?.message || 'User created and assign role successfully');
                setAlertType('success');
                form.resetFields();
                setTimeout(() => {
                    setAlertMessage("")
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating user');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating user.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>User With Role</h1>
            <Card title="Add User With Role" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                    initialValues={{
                        gender: '',
                        availability: [{}],
                        working_hours: [{}]
                    }}
                >
                    <Form.Item
                        label="First Name"
                        name="first_name"
                        rules={[{ required: true, message: 'Please input first name!' }]}
                    >
                        <Input placeholder="Enter first name" />
                    </Form.Item>
                    <Form.Item
                        label="Last Name"
                        name="last_name"
                        rules={[{ required: true, message: 'Please input last name!' }]}
                    >
                        <Input placeholder="Enter last name" />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter your email' },
                            { type: 'email', message: 'Please enter a valid email' }
                        ]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>
                    <Form.Item
                        label="Address"
                        name="address"
                        rules={[{ required: true, message: 'Please input address!' }]}
                    >
                        <Input placeholder="Enter address" />
                    </Form.Item>
                    <Form.Item
                        label="Gender"
                        name="gender"
                        rules={[
                            { required: true, message: 'Please select gender' },
                        ]}
                    >
                        <Select
                            options={[
                                { value: '', disabled : true, label: <span>Select gender</span> },
                                { value: 'male', label: <span>Male</span> },
                                { value: 'female', label: <span>Female</span> },
                                { value: 'other', label: <span>Othder</span> },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[{ required: true, message: 'Please input phone!' }]}
                    >
                        <InputNumber placeholder="Enter phone" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Please input password!' }]}
                    >
                        <Password placeholder="Enter password" />
                    </Form.Item>
                    <Form.Item
                        label="Role"
                        name="role"
                        rules={[
                            { required: true, message: 'Please select role' },
                        ]}
                    >
                        <Select
                            options={roles?.data?.map((data) => {
                                return (
                                    { value : data?._id, label : data?.name }
                                )
                            })}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AddSubAdmin;